var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 456 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    x1: -2.246,
    y1: 52.321,
    x2: 182.89,
    y2: 52.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#612d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#a21a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    y1: 46.438,
    x2: 182.595,
    y2: 46.438,
    xlinkHref: "#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    x1: 459.638,
    y1: 27.848,
    x2: 269.397,
    y2: 27.848,
    xlinkHref: "#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    x1: 459.638,
    y1: 21.881,
    x2: 269.003,
    y2: 21.881,
    xlinkHref: "#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    x1: 224.792,
    y1: 29.671,
    x2: 235.776,
    y2: 29.671,
    gradientTransform: "rotate(-180 230.284 29.67)",
    xlinkHref: "#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd",
    x1: 227.261,
    y1: 29.671,
    x2: 216.277,
    y2: 29.671,
    xlinkHref: "#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M181.64 32.662c-.718.036-16.782.792-36.635-6.195-2.439-.859-4.975-1.897-7.426-2.902-14.879-6.095-27.729-11.358-37.246 9.098-2.735 5.879-4.819 11.379-6.657 16.232-6.711 17.714-17.089 37.643-40.349 37.643-20.924 0-54.322-21.875-54.322-21.875",
    stroke: "url(#SVGID_0_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M181.345 26.669c-.164.01-15.659.715-34.348-5.863-2.296-.808-4.651-1.772-7.144-2.794-14.714-6.026-33.027-13.529-44.961 12.119-2.828 6.079-4.753 11.769-6.828 16.638-7.121 16.713-15.767 33.978-35.26 33.978-17.023 0-53.8-22.842-53.8-22.842",
    stroke: "url(#SVGID_1_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M270.647 32.332c.137-.009 13.73-.759 31.718 6.979l1.801.781c7.25 3.155 17.733 7.718 29.065 7.718 10.552 0 21.842-3.958 31.938-16.692 18.418-23.233 30.167-23.229 34.845-23.229 17.309 0 53.176 20.475 58.374 37.975",
    stroke: "url(#SVGID_2_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M270.253 26.345c.606-.041 15.074-.895 34.482 7.454l1.824.791c14.271 6.21 35.835 15.595 53.907-7.201 20.209-25.49 33.648-25.419 39.548-25.505 14.883-.217 43.646 13.31 58.374 32.622",
    stroke: "url(#SVGID_3_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M244.83 49.715h-10.304V9.627h10.304c11.063 0 20.044 8.981 20.044 20.044s-8.981 20.044-20.044 20.044z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M267.445 34.759h-2.571V24.582h2.571a3.01 3.01 0 013.008 3.008v4.162a3.01 3.01 0 01-3.008 3.008zM207.222 9.626h10.304v40.088h-10.304c-11.063 0-20.044-8.981-20.044-20.044s8.981-20.044 20.044-20.044z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M184.608 24.582h2.571v10.177h-2.571a3.01 3.01 0 01-3.008-3.008v-4.162a3.01 3.01 0 013.008-3.008z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 226.042,
    y: 5.616,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219,
    transform: "rotate(180 230.284 29.67)",
    stroke: "url(#SVGID_4_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 217.527,
    y: 5.616,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219,
    stroke: "url(#SVGID_5_d15397ed70dc999a924bebabcaf5027229d871daea85790aa7c967966e24dfbd)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.51b3cee249667a74b9526cfd0466ee21.svg";
export { ForwardRef as ReactComponent };